import { RewardCafeteriaService } from './RewardCafeteriaService';

export default {
	'services.rewardCafeteriaService': {
		class: RewardCafeteriaService,
		deps: [{ $ref: 'services.APIService' }, { $ref: 'services.currencyService' }],
	},
};
